import { TRUCK_REQUIREMENT__FACTOR_2 } from "../constants/global.constants";

export const validateInputNum = (val, min, max, unit, shouldBeInteger) => {
  const isValid = /^-?\d*\.?\d*$/.test(val);
  const isNegative = /^-/.test(val);

  if (!isValid) {
    return "Please enter a valid number.";
  }

  const numValue = Number(val);

  // Validate that if min is 0, negative numbers are not allowed
  if (Number(min) >= 0 && isNegative) {
    return "Value cannot be negative.";
  }

  // Validate against the maximum value
  if (max && numValue > Number(max)) {
    return `Value cannot be greater than ${max} ${unit}.`;
  }

  // Validate against the minimun value
  if (min && numValue < Number(min)) {
    return `Value cannot be smaller than ${min} ${unit}.`;
  }

  // Validate that the value should be an integer
  if (shouldBeInteger && !Number.isInteger(numValue)) {
    return "Value must be an integer.";
  }

  // If all validations pass, return null
  return null;

  /* if (isValid) {
    if (Number(min) === 0 && isNegative) {
      return "Value cannot be negative";
    } else if (max && Number(val) > Number(max)) {
      return `Value cannot be greater than ${max}${unit}`;
    } else {
      return null;
    }
  } else {
    return "Please enter a valid number";
  } */
};

export const validateInputMinMaxArea = (val, unit, minArea, maxArea) => {
  const numValue = Number(val);

  // Validate against the maxArea
  if (maxArea && numValue && numValue > Number(maxArea)) {
    return `Value cannot be greater than max. Area (${maxArea} ${unit}).`;
  }

  // Validate against the minArea
  if (minArea && numValue && numValue < Number(minArea)) {
    return `Value cannot be smaller than min. Area (${minArea} ${unit}).`;
  }

  // If all validations pass, return null
  return null;
};

export const validateBuildingName = (name, type) => {
  // Rule 1: Check if the name is provided
  if (!name || name.trim() === "") {
    return `This field is required and cannot be empty.`;
  }

  // Rule 2: Check for length (max 50 characters)
  if (name.trim().length > 50) {
    return `${type} name must not exceed 50 characters.`;
  }

  return null;
};

export const validateDockingStations = (
  numberOfDockingStations,
  buildingArea,
  truckRequirement
) => {
  if (
    !numberOfDockingStations ||
    numberOfDockingStations === -1 ||
    buildingArea === -1
  ){
    return null;
  }
  const factor = 3.5 /* TRUCK_REQUIREMENT__FACTOR_2[truckRequirement] */;
  // Calculate the total required width for the docking stations.
  const requiredWidth = 1.5 * numberOfDockingStations + (factor/2) * numberOfDockingStations + 4.5;
  // Estimate the available width from the building area.
  const availableWidth = buildingArea / 12;

  if (requiredWidth < availableWidth) {
    return null;
    
  } else {
    return "The amount of Docking Stations doesn't fit with the Axis Grid of the Building. Please either increase the Building's area or reduce the number of Docking Stations.";
  }
};
